export { default as DefaultPage } from './DefaultPage';
export { default as ListCatalog } from './ListCatalog';
export { default as CreateCatalogModel } from './CreateCatalogModel';
export { default as CreateCatalog } from './CreateCatalog';
export { default as CatalogInfo } from './CatalogInfo';



// WEBPACK FOOTER //
// ./src/features/dc/index.js